import React, { useEffect } from 'react'
import { MFASelectionScreen } from '../Components'
import styled from '@emotion/styled'
import { font, spacing } from '@mobi/component-library/Theme/Common'
import { MainContainer } from '@core/Components/Containers'
import { SettingsHeader } from '@core/Areas/Settings/SettingsHeader'
import { isCognitoUserAuthenticated } from '../Hooks/useCognitoUserIsAuthenticated'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'
import { lessThan } from '@mobi/component-library/Utils/media'
import { MFADeviceGroup } from '../Components/MFADeviceGroup'
import { useSelector } from 'react-redux'
import { getIsCognitoContactSyncing } from '@core/Areas/Login/Store/selectors'
import { triggerNonBlockingCognitoContactSync } from '../Services/mfaService'

export const MFASelectionPage: React.FC = () => {
  const { accountNumber } = useAuthenticatedAccount()
  const isCognitoContactSyncing = useSelector(getIsCognitoContactSyncing)

  useEffect(() => {
    // warm the cache to see if the user is_authenticated
    isCognitoUserAuthenticated(true)
    if (!isCognitoContactSyncing && accountNumber) {
      triggerNonBlockingCognitoContactSync(accountNumber)
    }
  }, [])

  return (
    <MainContainer data-tid-mfa-selection-page>
      <SettingsHeader title='Settings' />
      <PageContainerStyled>
        <PageContentStyled>
          <HeaderStyled>Multi-factor Authentication (MFA)</HeaderStyled>
          {accountNumber ? <MFASelectionScreen accountNumber={accountNumber} /> : null}
          {accountNumber ? <MFADeviceGroup accountNumber={accountNumber} /> : null}
        </PageContentStyled>
      </PageContainerStyled>
    </MainContainer>
  )
}

// ======
// Styles
// ======

const PageContainerStyled = styled.div({
  padding: `${spacing.bigx1} ${spacing.md}`,
  p: { textAlign: 'left' },
})

const PageContentStyled = styled.div({
  display: 'flex',
  padding: `0 ${spacing.md}`,
  flexDirection: 'column',
  alignSelf: 'stretch',

  [lessThan('px425')]: {
    padding: spacing.smx2,
  },
})

const HeaderStyled = styled.h1({
  margin: 0,
  fontFamily: font.family.primary,
  ...font.size.lg,
  fontWeight: font.weight.semibold,
})
